import { Box, Divider, Fade, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

const ContextMenu = ({ contextMenu, setContextMenu, options }) => {
    return (
        <>
            <Menu
                open={contextMenu !== null}
                onClose={() => setContextMenu(null)}
                anchorReference="anchorPosition"
                anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
                slots={{
                    transition: Fade,
                }}
                slotProps={{
                    paper: {
                        style: {
                            borderRadius: 5,
                            boxShadow: 'none',
                            opacity: 0.95,
                            border: '1px solid rgba(0,0,0,0.1)',
                        },
                    },
                }}
                sx={{ cursor: 'pointer' }}
            >
                {options
                    .filter((option) => option.privilege)
                    .map((option, index) => (
                        <Box key={index}>
                            {index !== 0 && options[index - 1].group !== option.group ? <Divider /> : null}

                            <MenuItem key={index} onClick={option.click} disabled={option.disabled}>
                                <ListItemIcon>{option.icon}</ListItemIcon>
                                <ListItemText>{option.name}</ListItemText>
                            </MenuItem>
                        </Box>
                    ))}
            </Menu>

            {options
                .filter((option) => option.privilege)
                .map((option, index) => (
                    <Box key={index}>{option.dialog}</Box>
                ))}
        </>
    );
};

export { ContextMenu };
